import { render, staticRenderFns } from "./recommend-create.vue?vue&type=template&id=71bdc4f8"
import script from "./recommend-create.vue?vue&type=script&lang=js"
export * from "./recommend-create.vue?vue&type=script&lang=js"
import style0 from "./recommend-create.vue?vue&type=style&index=0&id=71bdc4f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports